<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>派工看板</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel">
      <div class="">
        <div class="guides">
          <span>状态筛选</span>
          <span class="statuses">
            <span
              class="guide text-default"
              :class="{ active: this.filterStatus == 0 }"
              @click="filter(0)"
            >
              <span class="bg-default"></span>
              待分配
            </span>
            <span
              class="guide text-primary"
              :class="{ active: this.filterStatus == 1 }"
              @click="filter(1)"
            >
              <span class="bg-primary"></span>
              未开始
            </span>
            <span
              class="guide text-info"
              :class="{ active: this.filterStatus == 2 }"
              @click="filter(2)"
            >
              <span class="bg-info"></span>
              进行中
            </span>
            <span
              class="guide text-warning"
              :class="{ active: this.filterStatus == 3 }"
              @click="filter(3)"
            >
              <span class="bg-warning"></span>
              待检验
            </span>
            <span
              class="guide text-danger"
              :class="{ active: this.filterStatus == 4 }"
              @click="filter(4)"
            >
              <span class="bg-danger"></span>
              检验不合格
            </span>
            <span
              class="guide text-success"
              :class="{ active: this.filterStatus == 100 }"
              @click="filter(100)"
            >
              <span class="bg-success"></span>
              已完成
            </span>
          </span>
        </div>
        <!-- <div class="row filter-user">
              <span>人员筛选</span>
              <div class="filter-user-selector">
                <multiselect
                  v-model="filterUser"
                  label="name"
                  selectedLabel
                  selectLabel
                  deselectLabel=" "
                  placeholder="输入或选择执行人"
                  :options="users"
                >
                  <span slot="noResult">无匹配结果</span>
                  <span slot="noOptions">无可选执行人</span>
                </multiselect>
              </div>
            </div>-->
        <div style="margin-top: 12px" v-if="flows.length == 0">
          还未开始生产流程。
        </div>
        <div class="flows" v-for="(flow, x) in flows" :key="flow.id">
          <div class="flow-head">
            <div class="flow-head-title">
              <div class="flow-head-title-info">
                <h4>{{ flow.product.name }}</h4>
                <p>
                  <span>生产流程：{{ flow.name }}</span>
                  <span v-if="flow.status != 0"
                    >开始时间：{{ dateDisplay(flow.start_time) }}</span
                  >
                </p>
              </div>
              <div style="min-width: 180px; text-align: right">
                <button
                  v-if="flow.status == 0"
                  slot="reference"
                  class="btn btn-mint btn-sm btn-labeled"
                  @click="startFlow(x)"
                >
                  <i class="btn-label ion-settings"></i>开始
                </button>
                <button
                  v-if="flow.status != 2"
                  slot="reference"
                  class="btn btn-sm btn-default"
                  @click="cancelFlow(x)"
                >
                  撤回
                </button>
                <button
                  style="margin-left: 10px"
                  v-if="flow.status != 2"
                  slot="reference"
                  class="btn btn-sm btn-default"
                  @click="pauseFlow(x)"
                >
                  暂停
                </button>
                <button
                  style="margin-left: 10px"
                  v-if="flow.status != 2"
                  slot="reference"
                  class="btn btn-sm btn-default"
                  @click="closeFlow(x)"
                >
                  关闭
                </button>
              </div>
            </div>
            <div class="flow-head-status"></div>
          </div>
          <div class="steps">
            <!-- <div class="line"></div> -->
            <div class="step tasklist" v-for="(group, y) in flow.taskGroups">
              <div class="circle" :class="{ current: y <= flow.current_step }">
                {{ y + 1 }}
              </div>
              <div
                @click="clickedTask(x, y, z)"
                class="task"
                v-for="(task, z) in group"
                :class="task.style.taskClass"
                v-bind:style="{
                  opacity:
                    filterStatus == -1 || filterStatus == task.status ? 1 : 0.2,
                }"
              >
                <span class="task-title">{{ task.name }}</span>
                <span class="task-user" v-if="task.user_id > 0">
                  {{ task.user_name }}
                </span>
                <span class="task-user" v-else-if="task.user_ids">待抢单</span>
                <span class="task-user" v-else>
                  <i class="ion-person"></i>
                </span>
                <span
                  v-if="task.inspect_logs.length > 0"
                  class
                  @click.stop="showInspectLogs(task)"
                >
                  <i class="ion-information-circled text-warning"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="AssignUserModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      style="display: none"
    >
      <div class="modal-dialog" style="width: 440px">
        <div class="modal-content">
          <!--Modal header-->
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
          </div>
          <!--Modal body-->
          <div class="modal-body" style="padding-top: 0">
            <div class="form-group">
              <label class="control-label" for="demo-text-input">执行人</label>
              <el-select
                v-model="selectUser.id"
                style="width: 100%"
                size="small"
              >
                <el-option
                  v-for="item in users.filter((item) => item.name)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <multiselect
                v-model="selectUser"
                label="name"
                selectedLabel
                selectLabel
                deselectLabel=" "
                placeholder="输入或选择执行人"
                :options="users.filter((item) => item.name)"
              >
                <span slot="noResult">无匹配结果</span>
                <span slot="noOptions">无可选执行人</span>
              </multiselect> -->
            </div>
            <div v-if="selectTask" class="form-group">
              <label class="control-label" for="demo-text-input">工时</label>
              <div class>
                <input
                  type="text"
                  id="demo-text-input"
                  class="form-control"
                  placeholder="输入工时"
                  v-model="selectManhour"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button data-dismiss="modal" class="btn btn-default" type="button">
              取消
            </button>
            <button class="btn btn-primary" @click="assignTask">保存</button>
          </div>
        </div>
      </div>
    </div>
    <check-task
      :task="selectTask"
      :inspector="selectInspector"
      v-on:handled="taskHandled"
    ></check-task>
    <inspect-log-viewer :logs="selectInspectorLogs"></inspect-log-viewer>
  </div>
</template>

<script>
import {
  flows,
  getTaskUsers,
  assignTask,
  startFlow,
  closeFlow,
  cancelFlow,
  pauseOrStartFlow,
} from '@/service/getData'
import Multiselect from 'vue-multiselect'
import { taskStyle } from '@/utils/index'
import checkTask from '@/views/produce/flow/check_task'
import inspectLogViewer from '@/components/InspectLogViewer'

export default {
  components: { Multiselect, checkTask, inspectLogViewer },
  data() {
    return {
      flows: [],
      users: [],
      selectUser: { id: '', name: '' },
      selectManhour: 0,
      assignTaskId: null,
      assignTaskY: null,
      assignTaskX: null,
      assignTaskZ: null,
      modalTitle: '选择执行人',
      filterStatus: -1,
      filterUser: null,
      fields: [],
      selectTask: null,
      selectInspector: null,
      selectInspectorLogs: [],
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await flows()
      let list = res.data.list
      let that = this
      this.flows = list.map((item) => {
        return that.handlerFlow(item)
      })

      let userRes = await getTaskUsers()
      this.users = userRes.data.list
    },
    handlerFlow(item) {
      var taskGroups = []
      item.tasks.map((task) => {
        let index = task.step
        if (!taskGroups[index]) {
          taskGroups[index] = []
        }
        task.style = taskStyle(task.status)
        taskGroups[index].push(task)
      })

      item.taskGroups = taskGroups
      return item
    },
    flowUpdated(tmp) {
      this.$message({
        showClose: false,
        duration: 1000,
        message: '更新成功！',
        type: 'success',
      })
      tmp.nodes = this.flows[this.editIndex].nodes
      this.flows[this.editIndex] = tmp
      this.editFlow = null
      this.editIndex = -1
    },
    clickedTask(x, y, z) {
      this.assignTaskX = x
      this.assignTaskY = y
      this.assignTaskZ = z

      const flow = this.flows[this.assignTaskX]
      const task = flow.taskGroups[this.assignTaskY][this.assignTaskZ]
      this.selectTask = task
      this.selectInspector = {
        id: flow.inspector_id,
        name: flow.inspector_name,
      }
      // this.selectManhour = task.node.manhour
      this.selectManhour = task.manhour

      if (task.status < 2) {
        if (this.canAssignTask(task, flow)) {
          this.openAssignUserModal(x, y, z)
        } else {
          this.$message({
            showClose: false,
            duration: 1500,
            message: '请等待前置任务检验后再分配人员',
            type: 'error',
          })
        }
      } else if (task.status == 3 || task.status == 4 || task.status == 100) {
        $('#TaskCheck').modal('show')
      }
    },
    canAssignTask(task, flow) {
      return true
      let currentStep = flow.current_step

      if (task.step <= currentStep) {
        return true
      }

      var canAssign = true

      for (let index = 0; index < flow.tasks.length; index++) {
        const item = flow.tasks[index]
        if (
          item.step == currentStep &&
          item.status != 100 &&
          item.node.focus_checked
        ) {
          canAssign = false
          break
        }
      }

      return canAssign
    },
    openAssignUserModal(x, y, z) {
      let task =
        this.flows[this.assignTaskX].taskGroups[this.assignTaskY][
          this.assignTaskZ
        ]
      if (task.user_id > 0) {
        this.selectUser = { id: task.user_id, name: task.user_name }
        this.modalTitle = '重新分配'
      } else {
        this.modalTitle = '分配任务'
      }

      $('#AssignUserModal').modal('show')
    },
    async assignTask() {
      if (!this.selectUser.id) {
        return
      }

      this.selectUser.name = this.users.filter(
        (item) => item.id == this.selectUser.id
      )[0].name

      let task =
        this.flows[this.assignTaskX].taskGroups[this.assignTaskY][
          this.assignTaskZ
        ]
      let data = {
        task_id: task.id,
        manhour: parseInt(this.selectManhour),
        user_id: this.selectUser.id,
        user_name: this.selectUser.name,
      }

      let res = await assignTask(data)
      if (res.code == 0) {
        let flow = this.flows[this.assignTaskX]
        let taskGroups = flow.taskGroups
        taskGroups[this.assignTaskY][this.assignTaskZ].user_id =
          this.selectUser.id
        taskGroups[this.assignTaskY][this.assignTaskZ].user_name =
          this.selectUser.name
        this.$set(this.flows, this.assignTaskX, flow)
        $('#AssignUserModal').modal('hide')
        this.selectUser = { id: '', name: '' }
        this.$message({
          showClose: false,
          duration: 1000,
          message: '操作成功',
          type: 'success',
        })
      }
    },
    startFlow(index) {
      let that = this
      this.$confirm('确认开始生产流程？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: that.flows[index].id,
          }
          startFlow(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '生产流程已开始',
                type: 'success',
              })
              that.$set(that.flows, index, that.handlerFlow(res.data))
            }
          })
        })
        .catch(() => {})
    },
    cancelFlow(index) {
      let that = this
      this.$confirm('确认撤回生产流程？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: that.flows[index].id,
          }
          cancelFlow(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '生产流程已撤回',
                type: 'success',
              })
              that.flows.splice(index, 1)
            }
          })
        })
        .catch(() => {})
    },
    closeFlow(index) {
      let that = this
      this.$confirm('确认关闭生产流程？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: that.flows[index].id,
          }
          closeFlow(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '生产流程已关闭',
                type: 'success',
              })
              that.flows.splice(index, 1)
            }
          })
        })
        .catch(() => {})
    },
    pauseFlow(index) {
      let that = this
      this.$confirm('确认暂停生产流程？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: that.flows[index].id,
          }
          pauseOrStartFlow(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '生产流程已暂停',
                type: 'success',
              })
              that.flows.splice(index, 1)
            }
          })
        })
        .catch(() => {})
    },
    showInspectLogs(task) {
      this.selectInspectorLogs = task.inspect_logs
      $('#InspectLogViewer').modal('show')
    },
    dateDisplay(date) {
      return date.split('T')[0]
    },
    filter(status) {
      if (this.filterStatus == status) {
        this.filterStatus = -1
      } else {
        this.filterStatus = status
      }
    },
    taskHandled(task) {
      this.$message({
        showClose: false,
        duration: 1000,
        message: '操作成功',
        type: 'success',
      })

      let flow = this.flows[this.assignTaskX]
      flow.taskGroups[this.assignTaskY][this.assignTaskZ].status = task.status
      flow.taskGroups[this.assignTaskY][this.assignTaskZ].style = taskStyle(
        task.status
      )
      this.$set(this.flows, this.assignTaskX, flow)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.text-primary {
  color: #1c3550 !important;
}
.actions span {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}

.steps {
  display: flex;
  /* overflow-x: scroll; */
  position: relative;
  flex-wrap: wrap;
}

.step {
  position: relative;
  min-width: 200px;
  max-width: 200px;
  margin-left: 16px;
  margin-right: 4px;
  margin-bottom: 12px;
  border-radius: 4px;
  padding: 5px;
}

.step .circle {
  position: absolute;
  left: -16px;
  top: 8px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: center;
  background-color: #fff;
  z-index: 2;
  font-size: 12px;
  font-family: 'Courier New', Courier, monospace;
}

.step .circle.current {
  background-color: #8bc34a;
  border-color: #8bc34a;
  color: #fff;
}

/* .step .circle::after {
  position: absolute;
  content: '';
  left: 50%;
  top: 18px;
  width: 1px;
  height: 20px;
  background-color: #eee;
} */

.task {
  padding: 0 10px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  cursor: pointer;
}

.task .task-title {
  height: 24px;
  line-height: 24px;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.task:hover {
  background-color: #f5f5f5;
}

.task:last-child {
  margin-bottom: 0;
}

.task-footer {
  margin-top: 10px;
  height: 33px;
}
.user-set {
  cursor: pointer;
}
.task-user {
  color: #294f75;
  width: 60px;
  text-align: right;
}
.ti-user {
  margin-right: 2px;
}

.ion-information-circled {
  margin-left: 2px;
}

.tasklist .task-footer {
  text-align: left;
}

.flows {
  /* padding-top: 10px; */
  border-top: 1px dotted #ddd;
}

.guides {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.guide {
  height: 100%;
  margin-left: 12px;
  display: flex;
  cursor: pointer;
  padding: 2px 8px;
  border: 1px solid #fff;
  border-radius: 3px;
}

.filter-user {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.filter-user-selector {
  margin-left: 12px;
  width: 200px;
}

.guide.active {
  border-color: #ab47bc;
}

.statuses {
  display: flex;
}
.guide span {
  display: inline-block;
  width: 2px;
  height: 12px;
  margin-right: 3px;
  margin-top: 2px;
}
.bg-default {
  background-color: #aaa;
}
.flow-head {
  margin: 10px 0;
  line-height: 22px;
}
.flow-head-title {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
}

.flow-head-title h4 {
  font-size: 12px;
  margin: 0;
}

.flow-head-title h4 span {
  font-size: 14px;
  font-weight: bold;
}

.flow-head-title-info p {
  margin-bottom: 0;
  font-size: 12px;
}

.flow-head-title-info p span {
  margin-right: 2em;
}

.field-show label {
  color: #333;
  font-size: 14px;
}
.field-show div {
  margin-bottom: 12px;
}
</style>

<style>
.field-show img {
  width: 80px;
  height: auto;
  max-height: 80px;
  margin-right: 10px;
}
</style>